import { Banner, BannerItem } from '@athena/forge';
import { getLocalizedString } from '../../utils/i18n-utils';

export default function TooManyRequestsBanner() {
  const HEADER_TEXT = getLocalizedString('error.toomanyrequests.header');
  const HEADER_DESCRIPTION = getLocalizedString('error.toomanyrequests.description');

  return (
    <Banner alertType='attention' className='fe_u_padding--small'>
      <BannerItem headerText={HEADER_TEXT}>
        {HEADER_DESCRIPTION}
      </BannerItem>
    </Banner>
  );
}
